import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Admin, AdminValue } from '../models';

export const adminActions = createActionGroup({
    source: 'Admin',
    events: {
        // Get
        'Get Admin': props<{ id: string }>(),
        'Get Admin Success': props<{ payload: Admin }>(),
        'Get Admin Error': props<{ code: number }>(),
        // Create
        'Create Admin': props<{ value: AdminValue }>(),
        'Create Admin Success': props<{ payload: Admin }>(),
        'Create Admin Error': props<{ code: number }>(),
        // Update
        'Update Admin': props<{ id: string; value: AdminValue }>(),
        'Update Admin Success': props<{ payload: Admin }>(),
        'Update Admin Error': props<{ code: number }>(),
        // Delete
        'Delete Admin': props<{ id: string }>(),
        'Delete Admin Success': props<{ id: string }>(),
        'Delete Admin Error': props<{ code: number }>(),
        // Clear
        Clear: emptyProps(),
    },
});
